/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { _CancelRequestCancelledReason } from './_cancelRequestCancelledReason';

/**
 * Body for ``POST /enrollments/{id}/cancel``.
 */
export interface _CancelRequest {
  cancelled_reason?: _CancelRequestCancelledReason;
}
